import {
  useMediaAdCampaignSetPointsMutation,
  AdCampaignPureSetPointsMutationInput,
  MediaAdCampaignDocument,
} from '@shared/api/graphql/generated';

import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useAdSetPoints = (options: { refetch?: boolean } = {}) => {
  const [mutation, mutationResult] = useMediaAdCampaignSetPointsMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: AdCampaignPureSetPointsMutationInput) => {
    const mutationResult = await mutation({
      variables: { input },
      ...(options.refetch === false ? {} : { refetchQueries: [MediaAdCampaignDocument] }),
    });
    return mutationResult.data?.adcampaignSetPointsMutation?.ok === true && !mutationResult.errors?.length;
  };

  return {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    request,
  };
};

export default useAdSetPoints;
